import consola from 'consola';
import { get, post, put, del } from '@/js/api/sourcer';
import STATUS from '@/store/status';
import Config from '@/js/config';

const SET_STATUS = 'SET_STATUS';
const START_LOADING = 'START_LOADING';
const FINISH_LOADING = 'FINISH_LOADING';
const SET_READ = 'SET_READ';
const DELETE = 'DELETE';

const State = {
  value: {},
  status: STATUS.NOT_LOADED,
  operation: undefined,
};

// getters
const Getters = {
  listNotifications: (state) => {
    if (state.status === STATUS.LOADED) {
      return state.value;
    }
    return [];
  },
};

const Operation = async () => {
  try {
    const response = await get(`${Config.env.API_URL}notifications`);
    return response.data;
  } catch (e) {
    console.log(e);
  }
  return {};
};

// actions
const Actions = (operation) => ({
  async LOAD({ state, commit }, payload) {
    if (!(payload && payload.force)) {
      if (state.status === STATUS.LOADED) {
        return state.value;
      }

      // If there is a pending operation, wait it finish, and return value.
      if (state.status === STATUS.LOADING) {
        const response = await state.operation;
        return response;
      }
    }

    commit(START_LOADING, { operation });
    commit(FINISH_LOADING, { value: await state.operation });
    return state.value;
  },
  async [SET_READ](context, { notification }) {
    try {
      await put(`${Config.env.API_URL}notifications`, {
        notification_id: notification.id,
      });
    } catch (e) {
      console.log(e);
    }
    context.commit(SET_READ, { notification });
  },

  // async createNotification(context, { user_id, candidate_id }) {
  //   const n = await post(`${Config.env.API_URL}notifications`, {
  //     user_id,
  //     candidate_id
  //   })

  //   console.log('notification: ', n)
  // },

  async [DELETE](context, { notification }) {
    try {
      del(
        `${Config.env.API_URL}notifications?notification_ids=${notification.id}`
      );
    } catch (e) {
      console.log(e);
    }
    context.commit(DELETE, { notification });
  },
});

// mutations
const Mutations = {
  [SET_STATUS](state, { status }) {
    consola.info(`[${state.constructor.name}]:SetStatus ${status}`);
    state.status = status;
  },
  [START_LOADING](state, { operation }) {
    consola.info(`[${state.constructor.name}]:START_LOADING`);
    consola.info(operation);
    state.operation = operation();
    state.status = STATUS.LOADING;
  },
  [FINISH_LOADING](state, { value }) {
    consola.info(`[${state.constructor.name}]:FINISH_LOADING`);
    consola.info(value);
    state.value = value;
    state.status = STATUS.LOADED;
  },
  [DELETE](state, { notification }) {
    const index = state.value.findIndex((item) => item.id === notification.id);
    if (index > -1) {
      state.value.splice(index, 1);
    }
  },
  [SET_READ](state, { notification }) {
    // notification.read = true;
  },
};

export default {
  namespaced: true,
  state: State,
  getters: Getters,
  actions: Actions(Operation),
  mutations: Mutations,
};
